/**
 * Asynchronously loads the component for NurturingHistoryPage
 */

import { lazyLoad } from 'utils/loadable';

export const NurturingHistoryPage = lazyLoad(
  () => import('./index'),
  module => module.NurturingHistoryPage,
);
